import React from 'react'
import { CirclePlus, Search } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../../components/ui/alert-dialog'
import { Input } from '../../../../../components/ui/input'
import { useAddMembers } from './useAddMembers'
import { Button } from '../../../../../components/ui/button'
import { Spinner } from '../../../../../components/ui/spinner'
import { BasicAvatar } from '../../../../../components/BasicAvatar'

export const AddMembers = () => {
  const {
    data,
    handleSearchInputChange,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    ref,
    searchValue,
    handleAddUserToMemberList,
    handleSendMembersList,
    isPending,
    selectedUsers,
    handleResetMemberList,
  } = useAddMembers()

  return (
    <AlertDialog>
      <AlertDialogTrigger className="w-full">
        <div className="mt-4 flex w-full items-center justify-center space-x-2 rounded-full border-[1px] border-primary py-2">
          <CirclePlus size={16} className="text-primary" />
          <p className="font-medium text-primary">Adicionar membro</p>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent className="p-0">
        <AlertDialogHeader className="p-5">
          <AlertDialogTitle>Adicionar membros</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="border-b-[1px] border-white02" />
        <div className="px-5">
          <h2 className="text-sm font-medium">Membros</h2>
          <div className="relative my-2 flex items-center">
            <Search size={20} className="z-2 absolute left-4 top-3" />
            <Input
              className="ml-1 rounded-3xl pl-10"
              placeholder="Pesquisar vendedor"
              onChange={handleSearchInputChange}
              value={searchValue}
            />
          </div>
          <div className="container-bar h-80 overflow-y-auto">
            {data &&
              data.pages.map((page, index) => (
                <React.Fragment key={index}>
                  {page.users.map((user) => {
                    // Verifica se o usuário está selecionado
                    const isSelected = selectedUsers.some(
                      (selectedUser) => selectedUser._id === user._id,
                    )

                    return (
                      <div
                        key={user._id}
                        className="flex items-center justify-between"
                      >
                        <div className="my-4 flex items-center gap-3">
                          <BasicAvatar
                            name={user.name}
                            profileImageUrl={user.profileImageUrl}
                          />
                          <p className="text-sm font-semibold">{user.name}</p>
                        </div>
                        {!isSelected ? (
                          <CirclePlus
                            onClick={() => handleAddUserToMemberList(user)}
                            className="cursor-pointer"
                          />
                        ) : (
                          <div
                            onClick={() => handleAddUserToMemberList(user)}
                            className="cursor-pointer"
                          >
                            <i className="fa-solid fa-circle-check text-xl text-primary"></i>
                          </div>
                        )}
                      </div>
                    )
                  })}
                </React.Fragment>
              ))}
            <div className="mt-2 flex items-center justify-center" ref={ref}>
              <Button
                variant="ghost"
                disabled={!hasNextPage || isFetchingNextPage}
              >
                {isFetchingNextPage ? <Spinner /> : null}
              </Button>
            </div>
            <div>
              {isFetching && !isFetchingNextPage ? (
                <div className="flex items-center justify-center">
                  <Spinner />
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <AlertDialogFooter className="space-x-2 border-t-[1px] border-white02 p-5">
          <AlertDialogCancel
            onClick={handleResetMemberList}
            className="rounded-full bg-white02"
          >
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            type="submit"
            disabled={isPending}
            onClick={handleSendMembersList}
            className="rounded-full bg-primary text-white"
          >
            Salvar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
